import SvgComponent from "../../SVGComponent";

// Suggestions of props for component while using the components -------------------------------------
/**
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 */
/**
 * @typedef {("button" | "submit")} BtnType
 * @typedef {("white" | "black" | "blue")} HoverOption
 * @typedef {("right" | "left")} IconAlignment
 * @param {Object} props
 * @param {String} props.btnText - Default string to show
 * @param {BtnType} props.btnType - One of "button" or "submit"
 * @param {OnClickEventHandler} props.handleFunction - What to do when click on button
 * @param {boolean} props.isDisabled
 * @param {String} props.enabledTextColor - Color of text when button is enabled (var only)
 * @param {String?} props.disabledTextColor - Color of text when button is disabled (defaults to enabledTextColor) (var only)
 * @param {String} props.enabledBgColor - Color of bg when button is enabled (var only)
 * @param {String} props.disabledBgColor - Color of bg when button is disabled (var only)
 * @param {boolean} props.isLoading - Is something relevant loading right now (loading state)
 * @param {String?} props.outLineColor - Color of button outline (border color) (var only)
 * @param {String} props.icon - Takes svg as an props
 * @param {IconAlignment} props.iconToBeAlign - Icon should be on left or right
 * @param {HoverOption} props.hoverOption - Hover Option Black or White
 * @param {Object} props.buttonRef - Button ref (optional) eg:- state of button ref
 * @param {boolean} props.fullWidthRequired - Full width required (optional {if false then width will be auto}) eg:- true or false
 * @param {boolean} props.inActiveVariantNeeded - If you want to use inActive variant of button eg:- true or false
 * @param {String} props.imgColor - Takes svg color as an props
 * @param {boolean} props.textSemibold - If you don't want to semibold the text then pass false. Else by deault it is true eg:- true or false
 * @returns {JSX.Element}
 */
const PrimaryWithIconButton = ({
  btnText,
  btnType,
  handleFunction,
  isDisabled,
  enabledTextColor,
  disabledTextColor,
  enabledBgColor,
  disabledBgColor,
  isLoading,
  outLineColor,
  icon,
  iconToBeAlign,
  hoverOption,
  buttonRef,
  fullWidthRequired,
  inActiveVariantNeeded,
  imgColor,
  textSemibold,
  isAppBar,
}) => {
  return (
    <button
      ref={buttonRef ? buttonRef : null}
      type={btnType !== null ? btnType : "button"}
      onClick={(e) => {
        if (!isLoading) handleFunction(e);
      }}
      className={`flex z-z-index-base relative justify-center items-center py-padding-button-m ${iconToBeAlign === "right" ? "pl-padding-button-l pr-padding-sm" : "pl-padding-sm pr-padding-button-l "} ${fullWidthRequired ? "w-full" : "w-auto"} h-auto rounded-border-radius-md cursor-${
        isDisabled
          ? `not-allowed ${inActiveVariantNeeded ? "" : "opacity-light-opacity"} `
          : `pointer ${
              hoverOption === "white"
                ? "global-hover-white"
                : hoverOption === "blue"
                  ? "global-hover-blue"
                  : "global-hover-black"
            }`
      }`}
      style={{
        border: outLineColor ? `var(--border) solid ${outLineColor}` : "",
        backgroundColor:
          isDisabled && disabledBgColor
            ? disabledBgColor?.toString()
            : enabledBgColor?.toString(),
      }}
    >
      <div
        className={`flex flex-row items-center gap-gap-button-s ${fullWidthRequired ? "justify-center w-full " : ""} ${iconToBeAlign === "right" ? "flex-row-reverse " : ""} `}
      >
        <SvgComponent
          color={imgColor}
          height="var(--icon-sm)"
          width="var(--icon-sm)"
          url={icon}
          alt="CustomIcon"
        />
        <div
          className={`flex justify-center items-center text-font-xs ${textSemibold ? "font-semibold" : ""}  wrap-break-word ${iconToBeAlign === "right" && !isAppBar ? "font-normal" : "font-semibold"}`}
          style={{
            color:
              isDisabled && disabledTextColor
                ? disabledTextColor
                : enabledTextColor,
          }}
        >
          {btnText}
        </div>
      </div>
    </button>
  );
};

export default PrimaryWithIconButton;
